export default {
    daily: 'รายวัน',
    exportPDF: 'ดาวน์โหลด PDF',
    exportExcel: 'ดาวน์โหลด EXCEL'
}
